// src/theme/breakpoints.js
// Chakra UI'nin varsayılan breakpoint'leri çoğu proje için uygundur.

const breakpoints = {
  sm: "30em", // 480px
  md: "48em", // 768px
  lg: "64em", // 1024px (Chakra'nın 62em'inden biraz daha geniş)
  xl: "80em", // 1280px
  "2xl": "96em", // 1536px
};

// Object literal'i kullanmak yerine createBreakpoints API'sini de kullanabilirsiniz.
// import { createBreakpoints } from "@chakra-ui/theme-tools";
// const breakpoints = createBreakpoints({
//   sm: "30em",
//   md: "48em",
//   lg: "64em",
//   xl: "80em",
//   "2xl": "96em",
// });


export default breakpoints;
